import React from 'react';
import styled from 'styled-components';
import constants from 'utils/constants' 
export default function TutorialInfo() {
    let imgBasePath = constants['imagePath'] + "/tutorial_img/";
    return (
        <div>
            <div>
                <img alt={'toturial top moti'} src={`${imgBasePath}tutorial_top_img.png`}/>
            </div>

            <TutorialInfoWrapper>
                <TutorialTitleWrapper>
                    <TutorialTitleTxt>모티너스를 2배로 즐기는 사용설명서!👇</TutorialTitleTxt>
                </TutorialTitleWrapper>

                <StepWrapper>
                    <StepTitleWrapper>
                        <StepTitleTxt>Step 1. 내가 관심있는 모임에 가입</StepTitleTxt>
                    </StepTitleWrapper>
                    <StepDetailWrapper>
                        <StepDetailTxt>[홈화면] -> [관심모임 클릭] -> [하단 <Emphasize>모임 가입 버튼</Emphasize>] 클릭</StepDetailTxt>
                    </StepDetailWrapper>
                    <StepImageWrapper style={{padding: "calc(100vw*(19/375)) calc(100vw*(59/375))"}}>
                        <img src={`${imgBasePath}tutorial_step_1.png`} alt={'tutorial first step'}/>
                    </StepImageWrapper>
                </StepWrapper>

                <StepWrapper>
                    <StepTitleWrapper>
                        <StepTitleTxt>Step 2. 챌린지 참여</StepTitleTxt>
                    </StepTitleWrapper>
                    <StepDetailWrapper>
                        <StepDetailTxt>[모임 가입 후, 진행중인 챌린지에 참여 가능] -> [챌린지 참여시, <Emphasize>함께하는 투두리스트</Emphasize>가 내 투두리스트에 자동으로 쏘옥~!]</StepDetailTxt>
                    </StepDetailWrapper>
                    <StepImageWrapper style={{padding: "calc(100vw*(32/375)) calc(100vw*(16/375))"}}>
                        <img src={`${imgBasePath}tutorial_step_2.png`} alt={'tutorial second step'}/>
                    </StepImageWrapper>
                </StepWrapper>

                <StepWrapper>
                    <StepTitleWrapper>
                        <StepTitleTxt>Step 3. 투두리스트 작성방법</StepTitleTxt>
                    </StepTitleWrapper>
                    <StepDetailWrapper>
                        <StepDetailTxt>[하단 <Emphasize>투두리스트</Emphasize> 탭 클릭] -> [+버튼 누르고 투두리스트 추가]-> [모임에 <Emphasize>공유버튼</Emphasize> 클릭시 피드에 내 인증 사진 공유됨]</StepDetailTxt>
                    </StepDetailWrapper>
                    <StepImageWrapper style={{padding: "calc(100vw*(31/375)) calc(100vw*(3/375))"}}>
                        <img src={`${imgBasePath}tutorial_step_3.png`} alt={'tutorial thrid step'}/>
                    </StepImageWrapper>
                </StepWrapper>

                <StepWrapper>
                    <StepTitleWrapper>
                        <StepTitleTxt>Step 4. 투두리스트 사진인증</StepTitleTxt>
                    </StepTitleWrapper>
                    <StepDetailWrapper>
                        <StepDetailTxt>[해야 할 일 완료] -> [카메라 버튼을 클릭] -> [인증사진 업로드] -> [인증완료!] ->[모임에 공유한 경우 <Emphasize>모임 피드/실시간피드</Emphasize>에서  내 인증 확인가능]</StepDetailTxt>
                    </StepDetailWrapper>
                    <StepImageWrapper style={{padding: "calc(100vw*(25/375)) calc(100vw*(18/375))"}}>
                        <img src={`${imgBasePath}tutorial_step_4.png`} alt={'tutorial fourth step'}/>
                    </StepImageWrapper>
                </StepWrapper>

                <StepWrapper>
                    <StepTitleWrapper>
                        <StepTitleTxt>Step 5. 모임 커뮤니티 즐기기</StepTitleTxt>
                    </StepTitleWrapper>
                    <StepDetailWrapper>
                        <StepDetailTxt><Emphasize>모임 내 커뮤니티 탭</Emphasize> -> [모임 회원들과 정보 공유 및 일정 조율 등 자유롭게 대화 나눌 수 있음] <br /><Emphasize>모임 내 채팅 탭</Emphasize> -> [가벼운 대화들을 나눌 수 있음]</StepDetailTxt>
                    </StepDetailWrapper>
                    <StepImageWrapper style={{padding: "calc(100vw*(11/375)) calc(100vw*(42/375))"}}>
                        <img src={`${imgBasePath}tutorial_step_5.png`} alt={'tutorial fifth step'}/>
                    </StepImageWrapper>
                </StepWrapper>
            </TutorialInfoWrapper>
        </div>
    )
}

const TutorialInfoWrapper = styled.div`
    padding : calc(100vw*(37/375)) calc(100vw*(20/375));
    word-break: keep-all; 
    font-style: normal;
    background: #F7F7F7;
`;
const TutorialTitleWrapper = styled.div`
    margin-bottom: 30px;
`;
const TutorialTitleTxt = styled.span`
    font-weight: bold;
    font-size: calc(100vw*(24/375));
    line-height: calc(100vw*(35/375));
`;
const StepWrapper = styled.div`
    margin-bottom : 40px;
`;
const StepTitleWrapper = styled.div`
    margin-bottom: 9px;
`;
const StepTitleTxt = styled.span`
    font-weight: bold;
    font-size: calc(100vw*(18/375));
    line-height: calc(100vw*(26/375));
`;
const StepDetailWrapper = styled.div`
    margin-bottom: 15px;
`;
const StepDetailTxt = styled.span`
    font-weight: 500;
    font-size: calc(100vw*(14/375));
    line-height: calc(100vw*(21/375));
`;
const StepImageWrapper = styled.div`
    background: #FFFFFF;
    border-radius: 9px;
`
const Emphasize = styled.em`
    font-weight:bold;
`